export const getAuthorization = () => {
  const accessToken = localStorage.getItem("access_token");

  return `Bearer ${accessToken}`;
};
